import { toast } from 'react-toastify';
import { Storage, translate } from 'react-jhipster';
import * as moment from 'moment';

export const showTimer = (orderToken, history) => {

  const deleteStorageAndGoHome = () => {
    Storage.session.remove('ORDER_TOKEN');
    Storage.session.remove('SESSION');
    Storage.session.remove('TRANSACTION');
    Storage.session.remove('PI');
    Storage.session.remove('CART');
    history.push('/home');
    toast.error('選購限時已過！請重新開始');
  };

  const timeRemaining = orderToken.validUntil - moment().unix() * 1000;
  if (timeRemaining > 0) {
    const toastId = toast.info('', { autoClose: false });
    const startTimer = (duration, tid) => { // duration in seconds
      let timer = duration;
      let minutes;
      let seconds;
      const timerId = setInterval(() => {
        minutes = parseInt((timer / 60) + '', 10);
        seconds = parseInt((timer % 60) + '', 10);
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        toast.update(tid, { render: translate('order.remaingtime') + minutes + ':' + seconds });
        if (--timer < 0) {
          toast.dismiss();
        }
      }, 1000);

      // handling after session expired
      setTimeout(() => {
        clearInterval(timerId);
        deleteStorageAndGoHome();
      }, duration * 1000 + 1000); // do it after 1 sec
    };
    startTimer(orderToken.validUntil / 1000 - moment().unix(), toastId);
    return false;
  } else {
    deleteStorageAndGoHome();
  }
};

export const hideTimer = () => {
  toast.dismiss();
};
